
import { Button } from "@/components/ui/button";
import { Stethoscope, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ResultsHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-white/80 backdrop-blur-sm border-b border-blue-100">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <button 
            onClick={() => navigate("/")}
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
          >
            <div className="bg-gray-900 p-1.5 rounded-lg">
              <Stethoscope className="h-4 w-4 text-white" />
            </div>
            <h1 className="text-lg font-bold text-gray-900">AmIOK</h1>
          </button>
          <Button 
            variant="outline" 
            onClick={() => navigate("/")}
            className="text-blue-600 hover:text-blue-700 text-sm px-3 py-2"
            size="sm"
          >
            <Home className="mr-1 h-3 w-3" />
            Home
          </Button>
        </div>
      </div>
    </header>
  );
};

export default ResultsHeader;
